// extracted by mini-css-extract-plugin
export default {"container":"Rm-z","heading":"Sm-z","text":"Tm-z","info":"Um-z","link":"Vm-z","fullMaxWidth":"Wm-z"};